// Texty stránky Hodnocení obchodu (ratingsPage.js). Modul čte i nativní
// data Shoptetu (počty, skóre) — ta jsou čísla, ne text, do locale nepatří.
// Souhrn platforem nahoře bere věty z locale patičky (reviews.js `summaryLines`).
import { plural } from '../plural.js';

export default {
  eyebrow: 'Ověřeno zákazníky',
  /** perex: platformy souhrnu nahoře (návrh S, Tomáš 7. 10. 2026) */
  perex: 'Jak nás hodnotí zákazníci na Heurece, Zboží.cz, Googlu a přímo u nás.',
  /** nadpis karty s řádky platforem vedle souhrnu */
  platformsTitle: 'Hodnocení podle platforem',
  /** nadpis výpisu nativních hodnocení */
  listTitle: 'Co o nás píšou zákazníci',
  /** věta pod nadpisem výpisu: „3 816 hodnocení napsaných přímo u nás nebo převzatých z Heureky, průměrně 4,9 z 5." */
  listSub: (n, count, avg) =>
    n + ' '
    + plural(count, [
      'hodnocení napsané přímo u nás nebo převzaté z Heureky',
      'hodnocení napsaná přímo u nás nebo převzatá z Heureky',
      'hodnocení napsaných přímo u nás nebo převzatých z Heureky',
    ])
    + (avg ? ', průměrně ' + avg + ' z 5.' : '.'),
  filter: 'Filtrovat:',
  all: 'Vše',
  filterNote: 'Filtr pracuje s hodnoceními na aktuální straně výpisu.',
  empty: 'Žádná hodnocení v tomto filtru',
  emptyCta: 'Zobrazit vše',
  customer: 'Zákazník',
  verified: 'Ověřeno Heurekou',
  page: 'Strana ',
  monthDot: '. ',
  prevPage: 'Předchozí strana',
  nextPage: 'Další strana',
  pagerAria: 'Stránkování hodnocení',
  /** counter bez filtru: „Strana 1 z 5 · zobrazeno 30 z 2 869 hodnocení" */
  counterAll: (page, pages, shown, total) =>
    'Strana ' + page + ' z ' + pages + ' · zobrazeno ' + shown + ' z ' + total + ' hodnocení',
  /** counter s filtrem: „Filtr 5★: na této straně 12 z 30 hodnocení (celkem 900×)" */
  counterFiltered: (score, shown, total, bucketCount) =>
    'Filtr ' + score + '★: na této straně ' + shown + ' z ' + total + ' hodnocení'
    + (bucketCount != null ? ' (celkem ' + bucketCount + '×)' : ''),
  /**
   * Sekce „Jak recenze ověřujeme" (§ 5a odst. 5 ZOS, kotva reviews.verifyAnchor).
   * Znění schválil Tomáš 6. 10. (stránka) a 7. 10. 2026 (věta o štítku Hodnocení
   * obchodu, U3b), do sekce beze změny slov. `label` = štítek z locale
   * reviewHighlights, jak ho zákazník vidí u recenze.
   */
  verifyTitle: 'Jak recenze ověřujeme',
  verifyHeureka: (label) =>
    'Recenze označené „' + label + '“ pocházejí z dotazníku služby Heureka Ověřeno zákazníky, který Heureka posílá po nákupu u nás. Hodnocení přenášíme bez úprav textu.',
  verifyWeb: (label) => 'Recenze označené „' + label + '“ píší zákazníci přímo na našem webu a nákup u nich neověřujeme.',
  verifyBuyer: (label) =>
    'Hodnocení obchodu se štítkem „' + label + '“ napsali zákazníci, kteří si produkt u nás koupili (párujeme je přes číslo objednávky).',
  verifyShop: (label) => 'Hodnocení se štítkem „' + label + '“ se týkají nákupu u nás, ne konkrétního produktu.',
};
